import $ from 'jquery';


class ConsentForm {
    constructor(elem, opts, api) {
        this.api = api;
        this.opts = $.extend({
            defaultAcceptAll: true,
            inlineAutoConfirm: true,
        }, opts || {});

        let $elem = $(elem);
        if ($elem.hasClass('dsgvo-consent')) {
            this.$elem = $elem;
        } else {
            this.$elem = $elem.find('.dsgvo-consent');
        }
        this.isInline = !!this.$elem.hasClass('dsgvo-consent--inline');
        this._wasOpened = this.isInline;  // is automatically opened, so treated as "was opened" from beginning.

        this.$settings = $('.dsgvo-consent__settings', this.$elem);
        this.$settingsButton = $('.dsgvo-button__link--settings', this.$elem);
        this.$decline = $('.dsgvo-button__link--decline', this.$elem);
        this.$confirm = $('.dsgvo-button__link--confirm', this.$elem);
        this.$categoryCheckboxes = $('.dsgvo-category__checkbox', this.$elem);
        this.$serviceCheckboxes = $('.dsgvo-service__checkbox', this.$elem);
        this.initialize();
    }

    initialize() {
        let $toggleAbleServices = this.$serviceCheckboxes.not(':disabled');

        // register consent changes to update checkboxes.
        $toggleAbleServices.each((i, elem) => {
            this.api.on(`enable:${elem.value}`, _ => {
                elem.checked = true;
                this.updateCategoryState(elem.dataset.category);
            });
            this.api.on(`disable:${elem.value}`, _ => {
                elem.checked = false;
                this.updateCategoryState(elem.dataset.category);
            });
        });

        this.$categoryCheckboxes.each((i, elem) => this.updateCategoryState(elem.value));

        this.$categoryCheckboxes.on('change', ev => {
            let checkbox = ev.currentTarget;
            let $services = this.getServiceCheckboxes(checkbox.value).not(':disabled');
            $services.prop('checked', checkbox.checked);
            checkbox.indeterminate = false;
            this.autoConfirmInline();
        });

        $toggleAbleServices.on('change', ev => {
            this.updateCategoryState(ev.currentTarget.dataset.category);
            this.autoConfirmInline();
        });

        this.$settingsButton.on("click", ev => {
            let className = 'dsgvo-consent__settings--open';
            ev.preventDefault();
            if (this.$settings.hasClass(className)) {
                this.closeSettings(className);
            } else {
                this.openSettings(className);
            }
        });

        $('.dsgvo-cookies__check', this.$elem).on('change', ev => {
            this.$elem.toggleClass('dsgvo-consent--cookies-open', ev.currentTarget.checked);
            if (ev.currentTarget.checked) {
                this.markOpened();
            }
        });

        this.$decline.on("click", ev => {
            ev.preventDefault();
            this.api.confirm(this.getCheckedIdentifiers(true));
            this.closePopupIfNotInline();
        });

        this.$confirm.on("click", ev => {
            ev.preventDefault();
            this.api.confirm(this.getCheckedIdentifiers());
            this.closePopupIfNotInline();
        });

        window.setTimeout(() => {
            this.$elem.addClass('dsgvo-consent--fade-in');
        });
    }

    /**
     * @param {String} categoryIdentifier
     * @return {JQuery<HTMLInputElement>}
     */
    getServiceCheckboxes(categoryIdentifier) {
        return this.$serviceCheckboxes.filter((i, elem) => elem.dataset.category === categoryIdentifier);
    }

    /**
     * @param {String} categoryIdentifier
     */
    updateCategoryState(categoryIdentifier) {
        let $services = this.getServiceCheckboxes(categoryIdentifier);
        let checkedCount = $services.filter(':checked').length;
        this.$categoryCheckboxes.filter((i, elem) => elem.value === categoryIdentifier).each((i, elem) => {
            elem.checked = $services.length > 0 && checkedCount === $services.length;
            elem.indeterminate = checkedCount > 0 && checkedCount < $services.length;
        });
    }

    autoConfirmInline() {
        if (this.isInline && this.opts.inlineAutoConfirm) {
            this.api.confirm(this.getCheckedIdentifiers());
        }
    }

    markOpened() {
        this._wasOpened = true;
        this.$confirm.text(this.$confirm.attr('data-title-confirm'));
    }

    /**
     * @param className {String}
     */
    openSettings(className) {
        this.markOpened();
        this.$settings.addClass(className);
        this.$settingsButton.text(this.$settingsButton.attr('data-title-close'));
    }

    /**
     * @param className {String}
     */
    closeSettings(className) {
        this.$settings.removeClass(className);
        this.$settingsButton.text(this.$settingsButton.attr('data-title-open'));
        if (!this.opts.defaultAcceptAll) {
            this.$confirm.text(this.$confirm.attr('data-title-accept'));
        }
    }

    /**
     * Fully accepted categories are returned by their identifier, partially accepted ones as single service tokens.
     *
     * @param {Boolean} [requiredOnly]
     * @return {String[]}
     */
    getCheckedIdentifiers(requiredOnly) {
        let identifiers = [];
        // "defaultAcceptAll" accepts everything as long as the settings were not opened yet.
        let acceptAll = requiredOnly !== true && this.opts.defaultAcceptAll && !this._wasOpened;
        this.$categoryCheckboxes.each((i, categoryCheckbox) => {
            let $services = this.getServiceCheckboxes(categoryCheckbox.value);
            let $accepted = $services.filter((j, service) => {
                return requiredOnly === true ? service.disabled : (service.checked || acceptAll);
            });
            if ($services.length > 0 && $accepted.length === $services.length) {
                identifiers.push(categoryCheckbox.value.trim());
            } else {
                $accepted.each((j, service) => identifiers.push(service.value.trim()));
            }
        });
        return identifiers;
    }

    closePopupIfNotInline() {
        if (!this.isInline) {
            this.closePopup();
        }
    }

    closePopup() {
        if (!this.opts.inline) {
            this.$elem.removeClass('dsgvo-consent--fade-in');
            this.$elem.addClass('dsgvo-consent--fade-out');
            window.setTimeout(() => {
                this.$elem.remove();
            }, 500);
        }
    }
}

export default ConsentForm;
